import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-simpleeditdialog',
	templateUrl: './simpleeditdialog.component.html',
	styleUrls: ['./simpleeditdialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SimpleeditdialogComponent implements OnInit {
	public okReturnData: any;
	public cancelReturnData: any;
	public heading: string;
	public content: string;
	public okButtonText: string;
	public cancelButtonText: string;
	public textForm: FormGroup;
	public currentValue: any;

	constructor(
		public dialogRef: MatDialogRef<SimpleeditdialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
		Object.assign(this, this.data);
		this.textForm = new FormGroup<any>({
			textControl: new FormControl(this.currentValue, {
				validators: Validators.required,
				updateOn: 'change',
			}),
		});
	}

	ngOnInit(): void {}

	onOkClick() {
		this.dialogRef.close(this.textForm.value.textControl);
	}

	onCancelClick() {
		this.dialogRef.close(this.cancelReturnData || false);
	}
}
